module.exports = __webpack_public_path__ + "media/images/delete_button-c3756a43.svg";